/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class InfectedResourcesCountResponse {
  /**
  * The number of infected resources which is not mutted
  */
  'count'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "count",
      "baseName": "count",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return InfectedResourcesCountResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

